<template>
  <div class="layout">
    <!-- 顶部导航 -->
    <el-header style="min-width: 1600px">
      <LayoutHeader />
    </el-header>
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="250px" style="height: auto; overflow: visible">
        <div class="sidebar-box">
          <el-menu
            :default-active="menuActive"
            class="el-menu-vertical-demo"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#fff"
          >
            <el-menu-item
              class="level1-box"
              index="jiqiren"
              style="border-bottom: 1px solid rgb(67, 78, 88)"
            >
              <a href="http://steam.dd1218.cn/index" target="_blank">
                <span slot="title">机器人后台</span>
              </a>
            </el-menu-item>
            <div v-for="level1 in menuList" :key="level1.id">
              <el-submenu :index="level1.id" v-if="level1.children">
                <template slot="title">
                  <i class="el-icon-folder"></i>
                  <span slot="title">{{ level1.title }}</span>
                </template>

                <div v-for="level2 in level1.children" :key="level2.id">
                  <el-submenu
                    class="level2-box"
                    :index="level2.id"
                    v-if="level2.children"
                  >
                    <template slot="title">
                      <i class="el-icon-folder"></i>
                      <span slot="title">{{ level2.title }}</span>
                    </template>
                    <el-menu-item
                      class="level3-box"
                      :index="level3.id"
                      v-for="level3 in level2.children"
                      :key="level3.id"
                      @click="toPath(level3)"
                    >
                      <span @contextmenu.prevent="rightClick(level3)">{{
                        level3.title
                      }}</span>
                    </el-menu-item>
                  </el-submenu>
                  <el-menu-item
                    class="level2-box"
                    :index="level2.id"
                    @click="toPath(level2)"
                    v-else
                  >
                    <span @contextmenu.prevent="rightClick(level2)">{{
                      level2.title
                    }}</span>
                  </el-menu-item>
                </div>
              </el-submenu>
              <el-menu-item
                class="level1-box"
                :index="level1.id"
                @click="toPath(level1)"
                v-else
              >
                <span slot="title" @contextmenu.prevent="rightClick(level1)">{{
                  level1.title
                }}</span>
              </el-menu-item>
            </div>
          </el-menu>
        </div>
      </el-aside>

      <el-container style="min-width: 1600px">
        <!-- 右侧顶部分页 -->
        <div style="padding: 20px; width: 100%; text-align: left;box-sizing: border-box;">
          <el-tabs
            v-model="editableTabsValue"
            type="card"
            closable
            @tab-remove="removeTab"
            @tab-click="clickTab"
          >
            <el-tab-pane
              v-for="item in editableTabs"
              :key="item.id"
              :label="item.title"
              :name="item.id"
            >
            </el-tab-pane>
          </el-tabs>
          <div>
            <keep-alive :max="8">
              <router-view></router-view>
            </keep-alive>
          </div>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LayoutHeader from '@/components/layout/LayoutHeader'
import getMeus from '@/router/getMeus'
import routingList from '@/router/routingList.js' //路由列表
import routerTree from '@/router/routerTree.js' //路由列表
// import { resetRouter } from '@/router/index'

export default {
  name: 'home',
  components: {
    LayoutHeader
  },
  computed: {
    ...mapState({
      activeIndex: state => state.app.activeIndex,
      user_permissions: state => state.app.user_permissions
    })
  },
  data() {
    return {
      menuActive: '-1',//侧边栏当前选择菜单
      menuList: [],//侧边栏数据
      editableTabsValue: '-1',//顶部标签栏当前选择标签
      editableTabs: [
        {
          id: '-1',
          title: '首页',
          path: '/home',
        },
      ],//顶部标签栏数据
      tabIndex: 2,
      routerInfo: undefined,//保存监听路由，匹配到的信息
    }
  },
  watch: {
    $route: {
      handler(val, oldval) {
        //有缓存的标签页就拿缓存的
        if (sessionStorage.getItem('editableTabs')) {
          this.editableTabs = JSON.parse(sessionStorage.getItem('editableTabs'))
        }

        let info = this.getRouterInfo(routerTree, val.name);
        this.editableTabsValue = info.id;
        this.menuActive = info.id;
        //拼接路由数据，为的是保留全部所需参数
        let obj = {
          id: info.id,
          title: info.title,
          fullPath: val.fullPath,
          hash: val.hash,
          meta: val.meta,
          name: val.name,
          params: val.params,
          path: val.path,
          query: val.query
        }
        this.addTab(obj)//添加顶部标签
        // this.addTab(info)//添加顶部标签

        if (val.name === "login") {
          //返回登录页面，还原数据清除缓存
          this.editableTabsValue = '-1'//还原顶部标签栏当前选择标签
          this.editableTabs = [//还原顶部标签栏列表
            {
              id: '-1',
              title: '首页',
              path: '/home',
            },
          ]
          sessionStorage.removeItem('editableTabs')
          // resetRouter()//重置路由
        }
      },
      deep: true,// 深度观察监听
      immediate: true, //首次监听
    },
    user_permissions: {
      //监听权限变化
      handler(val, oldval) {
        this.getMenuList()
      },
      deep: true,// 深度观察监听
      immediate: true, //首次监听
    }
  },
  created() {
  },
  methods: {
    ...mapActions(['deleteLoginStatus']),
    //生成侧边栏菜单
    getMenuList() {
      if (this.user_permissions && this.user_permissions.length) {
        this.menuList = getMeus(this.user_permissions)
      } else if (sessionStorage.getItem('user_permissions')) {
        this.menuList = getMeus(JSON.parse(sessionStorage.getItem('user_permissions')))
      } else {
        //无权限，退出登录
        setTimeout(() => {
          this.deleteLoginStatus()
        })
      }
    },
    //切换页面
    toPath(info) {
      this.$router.push({ path: info.path })
      this.addTab(info)
    },
    //添加顶部标签
    addTab(tab_info) {
      let haveFlag = false
      for (const item of this.editableTabs) {
        if (item.id == tab_info.id) {
          //防止重复添加标签
          haveFlag = true
        }
      }
      if (!haveFlag) {
        this.editableTabs.push(tab_info);
        sessionStorage.setItem('editableTabs', JSON.stringify(this.editableTabs))
        this.removeMoreTab()//移除多余的tab
      }
    },
    //移除顶部标签
    removeTab(item) {
      // 数据统计标签不可去除
      if (this.editableTabs.length === 2) {
        this.$router.push({ path: '/home' })
      }
      if (item === '-1') {
        this.$message({
          message: '不能移除该项',
          type: 'warning'
        })
        return
      }

      let tabs = this.editableTabs;
      let activeId = this.editableTabsValue;
      // 筛选要移除的标签
      if (activeId === item) {
        tabs.forEach((tab, index) => {
          if (tab.id === item) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeId = nextTab.id;
            }
          }
        });
      }
      this.$router.push({ path: this.getPath(activeId) })//跳转对对应路由
      setTimeout(() => {
        //移除标签
        this.editableTabs = tabs.filter(tab => tab.id !== item);
        sessionStorage.setItem('editableTabs', JSON.stringify(this.editableTabs))
      })
    },
    // 点击顶部标签
    clickTab(item) {
      for (let i = 0, len = this.editableTabs.length; i < len; i++) {
        if (item.label === this.editableTabs[i].title) {
          this.menuActive = this.editableTabs[i].id
          //有三种方式，有参数的要传递参数
          if (this.editableTabs[i].query) {
            this.$router.push({ path: this.editableTabs[i].path, query: this.editableTabs[i].query })
          } else if (this.editableTabs[i].params) {
            this.$router.push({ name: this.editableTabs[i].path, params: this.editableTabs[i].params })
          } else {
            this.$router.push({ path: this.editableTabs[i].path })
          }
        }
      }
    },
    //根据id来获取路径
    getPath(id) {
      for (let i = 0, len = this.editableTabs.length; i < len; i++) {
        if (id === this.editableTabs[i].id) {
          return this.editableTabs[i].path
        }
      }
    },
    //根据路径来获取id
    getRouterInfo(list, name) {
      list.forEach(element => {
        if (element.name === name) {
          return this.routerInfo = element
        } else if (element.children) {
          this.getRouterInfo(element.children, name)
        }
      })

      return this.routerInfo
    },
    //移除多余tab
    removeMoreTab() {
      if (this.editableTabs.length > 8) {
        this.editableTabs.splice(1, 1)
        sessionStorage.setItem('editableTabs', JSON.stringify(this.editableTabs))
      }
    },
    rightClick(info) {
      if (!info.path) {
        return
      }

      this.$confirm('是否以新窗口打开该页面', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({ path: info.path })
        window.open(routeData.href, '_blank')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消打开该页面'
        })
      })
    }
  },
}
</script>

<style lang="less">
a {
  text-decoration: none;
  color: #fff;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  min-height: 400px;
  & > div {
    border-bottom: 1px solid rgb(67, 78, 88);
    .level2-box {
      border-bottom: 1px solid rgb(94, 96, 99);
      .level3-box {
        border-bottom: 1px solid rgb(94, 96, 99);
      }
    }
    .is-active {
      // #409eff
      background-color: rgb(44, 151, 212) !important;
    }
  }
}

.level2-box {
  background-color: rgb(78, 78, 78) !important;
  .el-submenu__title {
    background-color: rgb(78, 78, 78) !important;
  }
}

.level3-box {
  background-color: rgb(58, 58, 58) !important;
  .el-submenu__title {
    background-color: rgb(58, 58, 58) !important;
  }
}

.layout{
  width: 100%;
}

</style>
